import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms';

export function validateJson(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value === '') { return null; }
    try {
      JSON.parse(control.value);
      return null;
    } catch (e) {
      return {invalidJson: true};
    }
  };
}

// type DoesNotExistQuery = (input: string) => Observable<any>
// let timer;
// export function nameDoesNotExist(query: DoesNotExistQuery, delayMs?: number): ValidatorFn {
//   timer = setTimeout(query('test').toPromise().then(response => {
//     if(response.result) {
//       // Doesn't exist
//     } else {
//       // Exists
//     }
//   }), delayMs);
// }

export function atLeastOneEntityRequired(group: FormGroup): { [key: string ]: boolean } {
  const entityType = group.controls.entityType;
  const device = group.controls.device;
  const deviceMeasurement = group.controls.deviceMeasurement;
  const asset = group.controls.asset;
  const assetMeasurement = group.controls.assetMeasurement;

  if (entityType.value === 'DEVICE' && device.value && deviceMeasurement.value) {
    return null;
  }
  if (entityType.value === 'ASSET' && asset.value && assetMeasurement.value) {
    return null;
  }
  return {missingEntity: true};
}

export function noSpecialCharacters(control: FormControl): { [key: string]: boolean } {
  const nameRegexp: RegExp = /^[a-zA-Z0-9_\s-.-\u00C0-\u017F]+$/;
  if (control.value && !nameRegexp.test(control.value)) {
    return {specialChars: true };
  }
}

export function noWhitespaces(control: FormControl): { [key: string]: boolean } {
  const nameRegexp: RegExp = /[\s]/;
  if (control.value && nameRegexp.test(control.value)) {
    return {whitespaces: true };
  }
}
